import {
  FormTemplate as Data,
  FormTemplateCollection as Collection,
  FormTemplateCount,
} from '@/typings/api/FormTemplate'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { BaseApiResponse } from '@/typings/common'
import { AxiosRequestConfig } from 'axios'


export class FormTemplatesApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'data-collection/form-templates';

  public copy<R = BaseApiResponse<Data>>(
    id: Data['id'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = `${id}/copy/`
    const [url] = this.getUrl(path, params)
    return this.request<never, R>('POST', url, { params, ...config })
  }

  public count<R = BaseApiResponse<FormTemplateCount>>(
    id: Data['id'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = `${id}/form_data_count/`
    const [url] = this.getUrl(path, params)
    return this.request<never, R>('GET', url, { params, ...config })
  }
}
